import { createContext } from "react";
const defineStoreContext = createContext(null);
export {
  defineStoreContext
};
//# sourceMappingURL=context.js.map
